// --------------------------------------- Project List'


// snail la vie https://www.youtube.com/watch?v=7co2-ki2jA4
// https://the-game-assembly.itch.io/tga19-p8-snaillavie

// RoboCobra https://www.youtube.com/watch?v=WjXe-WLgLrc
// https://the-game-assembly.itch.io/tga19-p7-robocobra

// Buddhetti https://www.youtube.com/watch?v=rEIMpDNosI8

export const LargeProjectList = [
  {
    img: "./personal/SplashRender_tweaked.png",
    title: "Orb Striker",
    description:
      "An hyper casual mobile game",
    tech_stack: [ "C#", "Unity"],
    github_url: "",
    // app_store: "https://apps.apple.com/ph/app/touchgrind-x/id6449250454",
    // google_play: "https://play.google.com/store/apps/details?id=se.illusionlabs.tgx&hl=sv&pli=1",
    // tailer_url: "https://www.youtube.com/watch?v=Bgjt_NfhbPk"
  },
];

export const Personal = [
  {
    img: "./personal/frogling6.png",
    title: "Frogling",
    description:
      "An hyper casual mobile game about frogs with a lust for world domination",
    tech_stack: [ "C#", "Unity"],
    github_url: "",
    // app_store: "https://apps.apple.com/ph/app/touchgrind-x/id6449250454",
    // google_play: "https://play.google.com/store/apps/details?id=se.illusionlabs.tgx&hl=sv&pli=1",
    // tailer_url: "https://www.youtube.com/watch?v=Bgjt_NfhbPk"
  }
];

export const ProjectList = [
  {
    img: "./tga/snail_la_vie_2.png",
    title: "Snail La Via",
    description: "2.5D Platformer",

    project: "",
    detailed: "In this project, I focused on optimizing the engine and improving the in-house Editor's workflow and user experience.",
    contribution: "",

    youtube_url: "7co2-ki2jA4",

    // detailed: "As a part of the curriculum at The Game Assembly, we created three games with our in house Game Engine and Level Editor written in C++.",
    // "As a part of the curriculum at The Game Assembly, we created three games with our in house Game Engine and Level Editor written in C++.",
    // contribution: "", 
    // tech_stack: ["C++", "DirectX11", "DearImGui", "Git" ],
  },
  {
    img: "./tga/horror2.png",
    title: "RoboCobra",
    description:
      "FPS Game",

    project: "",
    detailed: "In this project, I focused on optimizing the engine and  improving the in-house Editor’s workflow and user experience. Also, I integrated Visual Scripting to our Editor, giving more independence for our level designers.",

    youtube_url: "WjXe-WLgLrc",
  },
  {
    img: "./tga/buddhetti_5.png",
    title: "Buddhetti",
    description:
      "Hack and Slash",

    project: "16 Week",
    // contribution: "Worked on our In-house Engine and Editor. UI and AI.",

    detailed: "In this group project, we highly focused on developing a solid ground for our new in-house engine. Parallel with the engine's development, we decided to create our own Level Editor. I worked on the pipeline, UX and engine features. I also worked on UI and enemies.",

    youtube_url: "rEIMpDNosI8",
  },
  {
    img: "./tga/8th_floor.png",
    title: "8th Floor",
    description:
      "Adventure Game ",

    project: "Adventure Game 8 Week",
    detailed: "Worked on core features such as Pathfinding, using A* algorithm, and VFX. I also worked on gameplay features such as the player, enemy and UI.",
    // Worked on the Pathfinding, using A* algorithm, The evil Nemisis, Player and VFX",

    youtube_url: "tV9_wMIzJxM",
  },
  {
    img: "./tga/soul_of_the_forest.png",
    title: "Soul Of the Forest",
    description:
      "2D Platformer",

    project: "2D Platformer",
    contribution: "",
    detailed: "Worked on core features such as Entity Component System. I also worked on the enemies.",

    youtube_url: "hMjXfXlFysw",
  },
  {
    img: "./tga/migrane_6.png",
    title: "Migrane",
    description:
      "Shoot em up",

    project: "2D Shoot em up made in Tga2D, C++",
    contribution: "",

    detailed: "Worked on the game foundation, adding core systems such as Entity Component Systems, QuadTree Collision Detection, Level Parser and VFX. I also worked features such as the player, enemies and UI",

    youtube_url: "8AJzweZqoAE"
  },
  // {
  //   img: "./cat.jpg",
  //   title: "Unfinished Projects",
  //   simple_text: "Unfinished projects and code snippets on my GitHub"
  //   // contribution: "",
  //   // tech_stack: [ "C#", "C++", "OpenGL", "DirectX", "SFML", "XNA" ],
  // },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/apple/apple-original.svg",
    name: "Apple",
  },
  {
    img: "https://github.com/devicons/devicon/blob/master/icons/android/android-original.svg",
    name: "Android"
  },
  {
    img: "https://github.com/devicons/devicon/blob/master/icons/cplusplus/cplusplus-original.svg",
    name: "C++"
  },
  {
    img: "https://github.com/devicons/devicon/blob/master/icons/csharp/csharp-original.svg",
    name: "C#"
  },



  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
  //   name: "HTML",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
  //   name: "CSS",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
  //   name: "JavaScript",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
  //   name: "ReactJS",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
  //   name: "NextJs",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
  //   name: "Typescript",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
  //   name: "Git",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
  //   name: "React Native",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
  //   name: "NodeJS",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
  //   name: "Firebase",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
  //   name: "MongoDB",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
  //   name: "Python",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg",
  //   name: "Flask",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
  //   name: "C",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //   name: "Java",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
  //   name: "MySQL",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
  //   name: "Bootstrap",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
  //   name: "Material UI",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
  //   name: "Figma",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-plain.svg",
  //   name: "TailwindCSS",
  // },
  // {
  //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
  //   name: "VS Code",
  // },
];
